export default "__VITE_ASSET__f871855b__"